import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from "@mui/material";

function OrderTransfer({ tableId, orderId }) {
  const [availableTables, setAvailableTables] = useState([]);
  const [selectedTableId, setSelectedTableId] = useState("");
  const [slugMapping, setSlugMapping] = useState({});
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchAvailableTables = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/Tables/order_table`);
        const data = res?.data?.items || [];

        const available = data.filter(
          (table) => table.tables_status === "available"
        );

        const mapping = {};
        available.forEach((t) => {
          mapping[t.id] = t.slug;
        });

        setAvailableTables(available);
        setSlugMapping(mapping);
      } catch (error) {
        console.error("Failed to fetch available tables:", error);
        toast.error("Could not load tables.");
      }
    };

    fetchAvailableTables();
  }, [API_BASE_URL]);

  const handleTransfer = async () => {
    if (!selectedTableId) {
      toast.error("Please select a table to transfer to.");
      return;
    }

    try {
      const res = await axios.post(`${API_BASE_URL}/orders/transferOrder`, {
        order_id: orderId,
        new_table_id: selectedTableId,
      });

      if (res?.data?.status === "Success") {
        toast.success("Order transferred successfully!");
        const newSlug = slugMapping[selectedTableId];
        if (newSlug) {
          navigate(`/take_order/${newSlug}`);
        } else {
          toast.warn("Transfer successful, but redirection failed.");
        }
      } else {
        toast.error(res?.data?.status_message || "Order transfer failed.");
      }
    } catch (error) {
      console.error("Error during order transfer:", error);
      toast.error("Error transferring order.");
    }
  };

  return (
    <Paper
      elevation={3}
      sx={{
        maxWidth: 400,
        mx: "auto",
        mt: 6,
        p: 4,
        borderRadius: 3,
        boxShadow: 6,
        backgroundColor: "#f9f9f9",
      }}
    >
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Transfer Order
      </Typography>

      <FormControl fullWidth sx={{ mt: 2 }}>
        <InputLabel id="table-select-label">Select Available Table</InputLabel>
        <Select
          labelId="table-select-label"
          value={selectedTableId}
          label="Select Available Table"
          onChange={(e) => setSelectedTableId(e.target.value)}
        >
          {availableTables.map((table) => (
            <MenuItem key={table.id} value={table.id}>
              {table.table_name} (Tables Name: {table.slug})
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 3 }}
        onClick={handleTransfer}
      >
        Transfer
      </Button>
    </Paper>
  );
}

export default OrderTransfer;
